export default __webpack_public_path__ + "static/media/Sorcerer's Leggings of the Emperor's Favor.e55d82cf.jpg";